import React, { useState, useEffect } from "react";
import ErrorBoundary from "../../common/ErrorBoundary";

import { DialogComponent } from "../../common/DialogComponent";
import PurchaseCreditReportDialog from "./PurchaseCreditReportDialog";
import PurchaseCreditReportCompleteDialog from "./PurchaseCreditReportCompleteDialog";

interface IProps {
    selectedProduct: any;
    onClose: any;
    changeTabCallback: any;
}

const PurchaseCreditReportDialogContainer: React.FunctionComponent<IProps> = (props: any) => {
    const [purchaseCreditReportDialog, setPurchaseCreditReportDialog] = useState(false);
    const [paymentCompleteDialog, setPaymentCompleteDialog] = useState(false);

    useEffect(() => {
        if (props.selectedProduct) {
            setPurchaseCreditReportDialog(true);
        }
    }, [props]);

    const handlePaymentCompleteDialog = (value: string): any => {
        if (value === "show") {
            setPaymentCompleteDialog(true);
        } else {
            setPaymentCompleteDialog(false);
            props.onClose();
        }
    };

    const handlePurchaseCreditReportDialog = (value: string): any => {
        if (value === "show") {
            setPurchaseCreditReportDialog(true);
        } else {
            setPurchaseCreditReportDialog(false);
            props.onClose();
        }
    };

    const closePurchaseAndOpenCompletionDialog = () => {
        setPurchaseCreditReportDialog(false);
        setPaymentCompleteDialog(true);
    };

    return (
        <React.Fragment>
            <ErrorBoundary componentName="Purchase Credit Report Dialog" type="showError" replaceDefaultContent={false} errorMsg="">
                {purchaseCreditReportDialog && (
                    <DialogComponent
                        dialogId="purchase-credit-report-your-cart-summary-dialog"
                        title="PurchaseCreditReportDialog"
                        datalayerEvent="Purchase Credit Report - Your Cart Summary"
                        closeDialog={() => {
                            handlePurchaseCreditReportDialog("close");
                        }}
                    >
                        <PurchaseCreditReportDialog
                            dialogId="purchase-credit-report-your-cart-summary-dialog"
                            selectedProduct={props.selectedProduct}
                            closeDialog={() => {
                                handlePurchaseCreditReportDialog("close");
                            }}
                            changeTabCallback={props.changeTabCallback}
                            closePurchaseAndOpenCompletionDialog={closePurchaseAndOpenCompletionDialog}
                        />
                    </DialogComponent>
                )}
            </ErrorBoundary>

            {paymentCompleteDialog && (
                <ErrorBoundary componentName="Purchase Credit Report Complete Dialog" type="showError" replaceDefaultContent={false} errorMsg="">
                    <DialogComponent
                        dialogId="purchase-credit-report-complete-done-dialog"
                        title="PurchaseCreditReportCompleteDialog"
                        datalayerEvent="Purchase Credit Report - Thank You"
                        closeDialog={() => {
                            handlePaymentCompleteDialog("close");
                        }}
                        hideCloseButton={true}
                    >
                        <PurchaseCreditReportCompleteDialog
                            selectedProduct={props.selectedProduct}
                            changeTabCallback={props.changeTabCallback}
                            closeDialog={() => {
                                handlePaymentCompleteDialog("close");
                            }}
                        />
                    </DialogComponent>
                </ErrorBoundary>
            )}
        </React.Fragment>
    );
};

export default PurchaseCreditReportDialogContainer;
